import log from './log';

export function tiktokPageView() {
	try {
		window.ttq?.page();
	} catch (e) {
		log.exception(e);
	}
}

export function tiktokIdentify(email: string, phone: string) {
	try {
		window.ttq?.identify({ email, phone_number: phone });
	} catch (e) {
		log.exception(e);
	}
}

// export function tiktokTrack(eventName: string) {
// 	try {
// 		window.ttq?.track(eventName);
// 	} catch (e) {
// 		Log.exception(e);
// 	}
// }
